import type { StrategyDetail } from '../types';
import type { StrategyWrite } from '../strategyApi';

export const STRATOS_MAPS: { id: string; name: string }[] = [
  { id: 'de_ancient', name: 'Ancient' },
  { id: 'de_anubis', name: 'Anubis' },
  { id: 'de_cache', name: 'Cache' },
  { id: 'de_dust2', name: 'Dust II' },
  { id: 'de_inferno', name: 'Inferno' },
  { id: 'de_mirage', name: 'Mirage' },
  { id: 'de_nuke', name: 'Nuke' },
];

export const STRATEGY_TYPES = ['execute', 'default', 'rush', 'retake', 'hold'] as const;
export const BUY_TYPES = ['full_buy', 'half_buy', 'eco', 'pistol'] as const;
export const ACTION_TYPES = ['move', 'hold', 'utility'] as const;
export const UTILITY_TYPES = ['smoke', 'flash', 'he', 'molotov', 'decoy'] as const;

export function canonicalBuy(raw: string | null | undefined): string {
  const key = (raw ?? '').trim().toLowerCase().replace(/[\s-]+/g, '_');
  if (key === 'full' || key === 'full_buy') return 'full_buy';
  if (key === 'half' || key === 'half_buy') return 'half_buy';
  if (key === 'eco') return 'eco';
  if (key === 'pistol') return 'pistol';
  return 'full_buy';
}

export function canonicalSide(raw: string | null | undefined): 'T' | 'CT' {
  return (raw ?? '').trim().toUpperCase() === 'CT' ? 'CT' : 'T';
}

/** 1:55 → 115. Requires two-digit seconds. Empty or out of range returns null. */
export function parseClock(raw: string): number | null {
  const match = /^(\d):(\d{2})$/.exec(raw.trim());
  if (!match) return null;
  const minutes = Number(match[1]);
  const seconds = Number(match[2]);
  if (seconds > 59) return null;
  const total = minutes * 60 + seconds;
  if (total > 115) return null;
  return total;
}

/** Blank stores null. A typed duration must be 1 through 115. Invalid input returns undefined. */
export function parseDuration(raw: string): number | null | undefined {
  const text = raw.trim();
  if (!text) return null;
  if (!/^\d+$/.test(text)) return undefined;
  const value = Number(text);
  if (value < 1 || value > 115) return undefined;
  return value;
}

export function strategyWrite(detail: StrategyDetail, status = detail.status): StrategyWrite {
  return {
    name: detail.name,
    map: detail.map,
    side: canonicalSide(detail.side),
    status,
    buyType: canonicalBuy(detail.buyType),
    strategyType: detail.strategyType ?? '',
    description: detail.description ?? '',
    site: detail.site ?? '',
    route: detail.route ?? '',
  };
}
